import { makeAutoObservable } from "mobx";
import { IRootStore } from "./RootStore";
import { RoleType } from "../components/main/body/screens/IAM/Roles/types/RoleType";
import { PermissionTableStateType } from "../components/main/body/screens/IAM/Users/types/PermissionTableStateType";
import { RightSidebarStateType } from "../components/main/body/common/right-sidebar/types/RightSidebarStateType";
import { PermissionType } from "../components/main/body/screens/IAM/Permissions/types/PermissionType";
import { UserType } from "../components/main/body/screens/IAM/Users/types/UserType";
import { OrganizationType } from "../components/main/body/screens/IAM/Users/types/OrganizationType";
import { RoleTableStateType } from "../components/main/body/screens/IAM/Users/types/RoleTableStateType";
import { UserFromFileType } from "../components/main/body/screens/IAM/Users/types/UserFromFileType";


interface DiversionRatio {
    diversionRecommended: number,
    notRecommended: number
}


export class AdminStore {

    // Home page states
    emergencyCount: number = 0;
    flightCount: number = 0;
    VideoCount: number = 0;
    diversionRatio: DiversionRatio = { diversionRecommended: 0, notRecommended: 0 }
    videocallTimelineData = [];
    medicalEmergenciesList: [] = [];
    homeFilter: boolean = false;
    filterDateStart: string;
    filterDateEnd: string;
    lastNDays = null;
    stepsHomeMedicalList : number = 6;
    medicalEmergencyStatusCount: number = 0;

    // Roles page states
    roles: RoleType[] = [];
    showPopup: boolean = false;
    clickedRole: RoleType[] = [];
    selectedRoles: (string | number)[] = [];
    showRightSidebarPermissionSelection: boolean = false;
    permissionTableState: PermissionTableStateType = {} as PermissionTableStateType;
    onSelectTriggerred: boolean = false;
    selectionActivated: boolean = false;
    showDeleteConfirmation: boolean = false;
    showAddUserModal:boolean = false;
    userShowEditProfileUser: boolean =false;
    editProfileUsername: string = "";
    rightSidebarPermissionsState: RightSidebarStateType<(string | number)[]> = {} as RightSidebarStateType<(string | number)[]>;
    // roleReload: number = 1;

    // create roles state
    permissions: PermissionType[] = [];
    selectedPermission: (string | number)[] = [];
    validationError: string = "";

    // users page states
    user: UserType[] = [];
    originalUsers: UserType[] = [];
    // selectedUsers: (string | number)[] = [];
    // userSelectionActivated: boolean = false;
    //  userOrganization: OrganizationType[] = [];
    //  userOrganizationId: string = "";
    //  userShowRightSidebarPermissionSelection: boolean = false;
    //  showRightSidebarRoleSelection: any = false;
     showCreateRolesModal:boolean = false;
    //  userPermissionTableState: PermissionTableStateType = {} as PermissionTableStateType;
    //  userRoleTableState: RoleTableStateType = {} as RoleTableStateType;

    selectedUsers:  any[] = [];
    userSelectionActivated: boolean = true;
    userOrganization: OrganizationType[] = [];
    userOrganizationId: string = "";
    userShowRightSidebarPermissionSelection: boolean = false;
    showRightSidebarRoleSelection: boolean = false;
    userPermissionTableState: PermissionTableStateType = {} as PermissionTableStateType;
    userRoleTableState: RoleTableStateType = {} as RoleTableStateType;

    userShowDisableConfirmation: boolean = false;
    rolesShowCloseButton : boolean = false;
    editRolesShowModal : boolean = false;
    userRightSidebarState: RightSidebarStateType<(string | number)[]> = {} as RightSidebarStateType<(string | number)[]>

    // create-user
    organizations: OrganizationType[] = [];
    selectedOrgId: string = "";
    selectedOrgName: string = "";
    showbatchButton: boolean = false;
    usersFromFile: UserFromFileType[] = [];

    AddedOrgId : string ="";
    usersActionMenu: boolean = false;
    usersSelectMenu: boolean = false;
    EditFlightOrgList: OrganizationType[] = [];
    Edit: OrganizationType[] = [];


    // create organization
    createOrgReset: number = 1;

    // create flight
    createFlightOrgList: OrganizationType[] = [];
;
    selectedOrganizationId: string = '-1';
    scheduleDeptureTime: string = "";
    ScheduleArriveTime: string = "";
    actualDeptureTime: string = "";
    actualArriveTime: string = "";

    update : number = 0;
    AddOrg : string = '';

    username: string="";
    email : string ="";
    firstName: string ="";
    family_name : string="";

    CustomType : string="";
    Organization: OrganizationType[] = [];
    gender : string = "";
    userStatus : string = "";



    RoleLabel: string = "";
    userEmail: string = "";
    TailNumber: string="";
    msn:string='';
    fleettype:string='';
    wifiProvider:string='';
    registration:string='';
    rootStore: IRootStore;


    constructor(rootStore: IRootStore) {
        this.filterDateStart = new Date().toISOString();
        this.filterDateEnd = new Date().toISOString();

        makeAutoObservable(this);
        this.rootStore = rootStore;
    }

    // Home page states setter and getter function
    handleEmergencyCount = (emergency: number) => {
        this.emergencyCount = emergency;
    }
    get getEmergencyCount() {
        return this.emergencyCount;
    }

    handleFlightCount = (flights: number) => {
        this.flightCount = flights;
    }
    get getFlightCount() {
        return this.flightCount;
    }

    handleVideoCount = (videos: number) => {
        this.VideoCount = videos;
    }
    get getVideoCount() {
        return this.VideoCount;
    }
    resetUserActionMenu =() =>{
        this.usersActionMenu = false;
    }
    get getUsersActionMenu() {
        return this.usersActionMenu;
    }
    resetUserSelectMenu =() =>{
        this.usersSelectMenu = false;
    }
    get getUsersSelectMenu() {
        return this.usersSelectMenu;
    }

    handleDiversionRatio = (newValue: DiversionRatio) => {
        this.diversionRatio = newValue;
    }
    get getDiversionRatio() {
        const dataValues = Object.values(this.diversionRatio);
        return dataValues;
    }

    handleVideocallTimelineData = (videoTimeLine: []) => {
        this.videocallTimelineData = videoTimeLine;
    }
    get getVideoTimeLineData() {
        return this.videocallTimelineData;
    }

    handleMedicalEmergenciesList = (emergencies: []) => {
        this.medicalEmergenciesList = emergencies;
    }
    get getMedicalEmergencyList() {
        return this.medicalEmergenciesList;
    }

    handleHomeFilter = (isFilterShow: boolean) => {
        this.homeFilter = isFilterShow;
    }
    get getHomeFilter() {
        return this.homeFilter;
    }

    handleFilterStartDate = (newDate: string) => {
        this.filterDateStart = newDate;
    }
    get getFilterStartDate() {
        return this.filterDateStart;
    }

    handleFilterEndDate = (newDate: string) => {
        this.filterDateEnd = newDate;
    }
    get getFilterEndDate() {
        return this.filterDateEnd;
    }

    handleLastNDay = (days: any) => {
        this.lastNDays = days
    }
    get getlastNDay() {
        return this.lastNDays;
    }

    handleStep = (steps: number) => {
        this.stepsHomeMedicalList = steps;
    }
    get getSteps() {
        return this.stepsHomeMedicalList
    }

    handleMedicalStateStatusCount = (steps: number) => {
        this.medicalEmergencyStatusCount = steps;
    }
    get getMedicalStateStatusCount() {
        return this.medicalEmergencyStatusCount
    }

    // Roles page setter and getter function
    handleRoles = (roles: RoleType[]) => {
        this.roles = roles;
    }
    get getRoles() {
        return this.roles;
    }

    handleCreateRolesModal =(value:boolean) =>{
        this.showCreateRolesModal =value;
    }
    get getCreateRolesModal(){
        return this.showCreateRolesModal;
    }

    handleShowPopUp = (isPopUpShow: boolean) => {
        this.showPopup = isPopUpShow;
    }
    get getPopUpShow() {
        return this.showPopup;
    }

    handleRightSidebarPermission = (rightSidebarpermission: boolean) => {
        this.showRightSidebarPermissionSelection = rightSidebarpermission;
    }
    get getRightSidebarPermission() {
        return this.showRightSidebarPermissionSelection;
    }
    setUsersSelectMenu = () =>{
        this.usersSelectMenu = !this.usersSelectMenu;
    }

    handlePermissionTableState = (permissionTableData: PermissionTableStateType) => {
        this.permissionTableState = permissionTableData;
    }
    get getPermissionTableState() {
        return this.permissionTableState;
    }

    handleOnSelectTrigger = (isSelectedTrigger: boolean) => {
        this.onSelectTriggerred = isSelectedTrigger;
    }
    get getOnSelectTrigger() {
        return this.onSelectTriggerred;
    }

    handleSelectedActivation = (isSelectActivate: boolean) => {
        this.selectionActivated = isSelectActivate;
    }
    get getSelectedActivation() {
        return this.selectionActivated;
    }

    handleDeleteConformation = (isDeleteConfirm: boolean) => {
        this.showDeleteConfirmation = isDeleteConfirm;
    }
    get getDeleteConformation() {
        return this.showDeleteConfirmation;
    }

    handleRightSidebarPermissionState = (newState: RightSidebarStateType<(string | number)[]>) => {
        this.rightSidebarPermissionsState = newState;
    }
    get getRightSidebarPermissionState() {
        return this.rightSidebarPermissionsState
    }

    // handleRoleReload = () => {
    //     this.roleReload++;
    // }
    // getRoleReload() {
    //     return this.roleReload;
    // }

    handleSelectedRoles = (roles: (string | number)[]) => {
        this.selectedRoles = roles;
    }
    get getSelectedRoles() {
        return this.selectedRoles;
    }

    // create roles page state
    handlePermissions = (permission: PermissionType[]) => {
        this.permissions = permission;
    }
    get getPermissions() {
        return this.permissions;
    }

    handleSelectedPermission = (selectedPermissions: (string | number)[] ) => {
        this.selectedPermission = selectedPermissions;
    }
    get getSelectedPermission() {
        return this.selectedPermission;
    }
    resetSelectedPermission = () => {
        this.selectedPermission = [];
    }

    handleValidationError = (errorMessage: string) => {
        this.validationError = errorMessage;
    }
    get getValidationError() {
        return this.validationError;
    }


    // users page state
    handleUsers = (users:   UserType[]) => {
        this.user = users;
    }
    get getUsers() {
        return this.user;
    }

    handleOriginalUsers = (users:   UserType[]) => {
        this.originalUsers = users;
    }
    get getOriginalUsers() {
        return this.originalUsers;
    }

    handleSelectedUser = (selectedUser: any []) => {
        this.selectedUsers = selectedUser;
    }
    get getSelectedusers() {
        return this.selectedUsers;
    }

    handleUserSelectedActivation = (isSelectActivate: boolean) => {
        this.userSelectionActivated = isSelectActivate;
    }
    get getUserSelectedActivation() {
        return this.userSelectionActivated;
    }

    handleUserOrganization = (organization: OrganizationType[]) => {
        this.userOrganization = organization;
    }
    get getUserOrganization() {
        return this.userOrganization;
    }

    handleUserOrgId = (orgId: string) => {
        this.userOrganizationId = orgId;
    }
    get getUserOrgId() {
        return this.userOrganizationId;
    }

    handleUserRightSidebar = (isRSidebarShow: boolean) => {
        this.userShowRightSidebarPermissionSelection = isRSidebarShow;
    }
    get getUserRightSidebarShow() {
         return this.userShowRightSidebarPermissionSelection;
     }
  
     handleUserRightSidebarRoleSelection = (isRSidebarShow: any) => {
         this.showRightSidebarRoleSelection = isRSidebarShow;
     }
     get getUserRightSidebarRoleSelection() {
        return this.showRightSidebarRoleSelection;
    }

    handleUserPermissionTableState = (UpermissionTableData: PermissionTableStateType) => {
        this.userPermissionTableState = UpermissionTableData;
    }
    get getUserPermissionTableState() {
        return this.userPermissionTableState;
    }

    handleUserRole = (roles: RoleTableStateType) => {
        this.userRoleTableState = roles;
    }
    get getUserRole() {
        return this.userRoleTableState;
    }

    handleUserShowDisableConfirmation = (newVal: boolean) => {
        this.userShowDisableConfirmation = newVal;
       
    }
    get getUserShowDisableConfirmation() {
        return this.userShowDisableConfirmation;
    }
    handleRolesShowCloseButton = (newVa1:boolean) =>{
       this.rolesShowCloseButton = newVa1;
    }
    get getRolesShowCloserConfirmation(){
        return this.rolesShowCloseButton;
    }
    handleEditRoles =(newVa1:boolean) =>{
        this.editRolesShowModal =newVa1;
    }
    get getEditRoles(){
        return this.editRolesShowModal;
    }

    handleUserRightSidebarState = (URightSidebarState: RightSidebarStateType<(string | number)[]>) => {
        this.userRightSidebarState = URightSidebarState;
    }
    get getUserRightSidebarState() {
        return this.userRightSidebarState;
    }
    handleEditFlightOrgList = (list: OrganizationType[]) => {
        this.EditFlightOrgList = list;
    }
    get getEditFlightOrgList() {
        return this.EditFlightOrgList;
    }
    // create user states
    handleOrgList = (orgList: OrganizationType[]) => {
        this.organizations = orgList;
    }
    get getOrgList() {
        return this.organizations;
    }
    setUsersActionMenu = () => {
        this.usersActionMenu = !this.usersActionMenu;
    }
    // setUsersActionMenu = (forceFalse = false) => {
    //     this.usersActionMenu = forceFalse ? false : !this.usersActionMenu;
    // }
      
    handleSelectedOrgId = (orgId: string) => {
        this.selectedOrgId = orgId;
    }
    get getSelectedOrgId() {
        return this.selectedOrgId;
    }
    handleSelectedOrgName = (orgId: string) => {
        this.selectedOrgName = orgId;
    }
    get getSelectedOrgName() {
        return this.selectedOrgName;
    }
    handleAddedOrgId = (AddedOrgId: string) => {
        this.AddedOrgId = AddedOrgId;
    }
    get getAddedOrgId() {
        return this.AddedOrgId;
    }

    handleShowBatchButton = (batchButton: boolean) => {
        this.showbatchButton = batchButton;
    }
    get getShowBatchButton() {
        return this.showbatchButton;
    }

    handleFormFile = (file: UserFromFileType[]) => {
        this.usersFromFile = file;
    }
    get getUserFormFile() {
        return this.usersFromFile;
    }

    // create organization states

    handleCreateOrgReset = () => {
        this.createOrgReset++;
    }
    get getCreateOrgResetCount() {
        return this.createOrgReset;
    }

    handleAddUserModal = (value: boolean) => {
        this.showAddUserModal = value;
    }
    get getAddUserModal() {
        return this.showAddUserModal;
    }

    // create flight states

    handleCreateFlightOrgList = (list: OrganizationType[]) => {
        this.createFlightOrgList = list;
    }
    get getCreateFlightOrgList() {
        return this.createFlightOrgList;
    }


    handleSelectedOrg = (orgId: string) => {
        this.selectedOrganizationId = orgId;
    }
    get getSelectedOrg() {
        return this.selectedOrganizationId;
    }

    handleSchdDepTime = (sdeptime: string) => {
        this.scheduleDeptureTime = sdeptime;
    }
    get getSchdDepTime() {
        return this.scheduleDeptureTime;
    }

    handleSchdArvTime = (sarvtime: string) => {
        this.ScheduleArriveTime = sarvtime;
    }
    get getSchdArvTime() {
        return this.ScheduleArriveTime;
    }

    handleActDepTime = (actdeptime: string) => {
        this.actualDeptureTime = actdeptime;
    }
    get getActDepTime() {
        return this.actualDeptureTime;

    }
    
    handleActArvTime = (actarvtime: string) => {
        this.actualArriveTime = actarvtime;
    }
    get getActArvTime() {
        return this.actualArriveTime;
    }

    handleRoleLabel = (rolename: string) => {
        this.RoleLabel = rolename;
    }
    get getRoleName() {
        return this.RoleLabel;
    }

    handleUserEmail = (email: string) => {
        this.userEmail = email;
    }
    get getUserEmail() {
        return this.userEmail;
    }

    handleTailNumber = (TailNumber: string) => {
        this.TailNumber = TailNumber;
    }
    get getTailNumber() {
        return this.TailNumber;
    }
    handleMsn = (msn: string) => {
        this.msn = msn;
    }
    get getMsn() {
        return this.msn;
    }
    handleEditProfileUser = (newVal: boolean) => {
        this.userShowEditProfileUser = newVal;
    }
    get getEditProfileUser() {
        return this.userShowEditProfileUser;
    }

    handleEditProfileUsername = (name: string) => {
        this.editProfileUsername = name;
    }
    get getEditProfileUsername() {
         return this.editProfileUsername;
    }
    handleAddOrg = (AddOrg: string) => {
        this.AddOrg = AddOrg;
    }
    get getAddOrg() {
        return this.AddOrg;
    }
    handleupdate = () => {
        this.update++;
    }
    get getupdate () {
        return this.update ;
    }

    handleUserName(username : string){
        // alert("sfsdfd"+this.username);
        this.username= username;
    }

    get getUsername(){ 
       return this.username;
    }

    handleEmail(email : string){
        this.email= email;
    }

    get getEmail(){ 
       return this.email;
    }
    handleFirstName(firstName : string){
        this.firstName= firstName;
    }

    get getFirstName(){ 
       return this.firstName;
    }
    handleFamilyname(family_name : string){
        this.family_name= family_name;
    }

    get getFamilyName(){ 
       return this.family_name;
    }
    handleCustomType(CustomType: string){
        this.CustomType= CustomType;
    }

    get getCustomType(){ 
       return this.CustomType;
    }
    handleGender(gender: string){
        this.gender= gender;
    }
    
    get getGender(){ 
        return this.gender;
    }
    handleUserStatus(userStatus: string){
        this.userStatus= userStatus;
    }
    
    get getUserStatus(){ 
        return this.userStatus;
    }
    
    
    handleOrganization(Organization: any){
        this.Organization= Organization;
    }

    get getOrganization(){ 
       return this.Organization;
    }
    handleEdit(Edit: any){
        this.Edit= Edit;
    }

    get getEdit(){ 
       return this.Edit;
    }
    
    handlefleettype = (fleettype: string) => {
        this.fleettype = fleettype;
    }
    get getfleettype() {
        return this.fleettype;
    }
    handleWifiProvider = (wifiProvider: string) => {
        this.wifiProvider = wifiProvider;
    }
    get getWifiprovider() {
        return this.wifiProvider;      
    }
    handleregistration = (registration: string) => {
        this.registration = registration;
    }
    get getregistration() {
        return this.registration;      
    }
}